import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { Icon } from '@iconify/react';
import AuthorWidget from '../Widget/AuthorWidget';
import { pageTitle } from '../../helpers/PageTitle';

export default function Blog8() {
  pageTitle('The Future of Renewable Energy: 2025 and Beyond');
  
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const data = {
      name: formData.get('name'),
      email: formData.get('email'),
      comment: formData.get('comment')
    };
    console.log('Sending to company email:', data);
  };

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="The Future of Renewable Energy: 2025 and Beyond"
        variant="text-center"
        shape="shape_5"
        category="Future Technology"
        date="02 Jan 2025"
        avatar="Innovation"
        avatarLink="/"
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <img
          src="/images/blog/post_details_1.jpeg"
          alt="Future of Energy"
          className="cs_radius_15"
        />
        <div className="cs_height_60 cs_height_lg_40" />
        <div className="cs_post_details">
          <h3>
            Emerging Technologies Reshaping the Energy Landscape
          </h3>
          <p>
            The renewable energy sector is on the cusp of revolutionary changes. From perovskite solar cells to advanced AI-driven power management, discover the innovations that will define the next decade of clean energy.
          </p>
          <p>
            Stay ahead of the curve with Soketry Solutions as we implement cutting-edge technologies that ensure your energy investments remain future-proof and efficient.
          </p>
          <div className="cs_height_10 cs_height_lg_5" />
          <div className="row">
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_2.jpeg"
                alt="Future Tech"
                className="w-100"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_3.jpeg"
                alt="Innovation"
                className="w-100"
              />
            </div>
            <div className="col-md-4">
              <img
                src="/images/blog/post_details_4.jpeg"
                alt="Next Gen"
                className="w-100"
              />
            </div>
          </div>
          <div className="cs_height_10 cs_height_lg_5" />
          <h3>Key Trends Shaping Tomorrow's Energy</h3>
          <p>
            From advanced energy storage solutions to integrated smart grid technologies, the future of renewable energy is more exciting than ever. Learn how these developments will impact your energy choices.
          </p>
          <blockquote>
            "The innovations we're implementing today at Soketry Solutions are laying the groundwork for a completely sustainable energy future. The technology is advancing faster than ever before."
            <small>Dr. Mark Reynolds, Chief Technology Officer</small>
          </blockquote>
          <p>
            Partner with Soketry Solutions to ensure your renewable energy system is ready for the future. Our forward-thinking approach means your installation will be compatible with emerging technologies.
          </p>
          <ul>
            <li>Next-generation solar panel efficiency (30%+ improvement)</li>
            <li>AI-powered energy management systems</li>
            <li>Advanced battery storage technologies</li>
            <li>Smart grid integration capabilities</li>
            <li>Blockchain energy trading platforms</li>
            <li>Quantum dot solar cells</li>
            <li>Virtual power plant networks</li>
            <li>Microgrids and community energy systems</li>
          </ul>
        </div>
        <div className="cs_height_30 cs_height_lg_10" />
        <div className="cs_post_share">
          <div className="cs_categories">
            <a href="/" className="cs_category">
              Future Tech
            </a>
            <a href="/" className="cs_category">
              Innovation
            </a>
          </div>
          <div className="text-center">
            <div className="cs_post_share_btns">
              <a href="/">
                <Icon icon="fa6-brands:twitter" />
              </a>
              <a href="/">
                <Icon icon="fa6-brands:facebook-f" />
              </a>
              <a href="/">
                <Icon icon="fa6-brands:linkedin-in" />
              </a>
            </div>
            <span className="cs_post_share_title">Share this Article</span>
          </div>
        </div>
        <div className="cs_height_50 cs_height_lg_40" />
        <AuthorWidget />
        <div className="cs_height_88 cs_height_lg 60" />
        <h2 className="text-center cs_fs_50 mb-0">Leave A Comment</h2>
        <div className="cs_height_60 cs_height_lg 30" />
        <form onSubmit={handleSubmit} className="row">
          <div className="col-lg-6">
            <input
              type="text"
              name="name"
              className="cs_form_field_2"
              placeholder="Your Name"
              required
            />
            <div className="cs_height_50 cs_height_lg 30" />
          </div>
          <div className="col-lg-6">
            <input
              type="email"
              name="email"
              className="cs_form_field_2"
              placeholder="Your Email"
              required
            />
            <div className="cs_height 50 cs_height_lg 30" />
          </div>
          <div className="col-lg-12">
            <textarea
              name="comment"
              cols={30}
              rows={7}
              className="cs_form_field_2"
              placeholder="Share your thoughts on future energy technologies"
              required
            />
            <div className="cs_height 60 cs_height_lg 30" />
          </div>
          <div className="col-lg-12 text-center">
            <button type="submit" className="cs_btn cs_style_1">
              Submit Comment{' '}
              <span>
                <i className="fa-solid fa-arrow-right" />
              </span>
            </button>
          </div>
        </form>
        <div className="cs_height_150 cs_height_lg 80" />
      </div>
    </>
  );
} 